import PropTypes from 'prop-types'
import LogoType from '../../atoms/LogoType'
import ContactItem from '../../atoms/ContactItem'
import defaults from '../../../config/defaults'

const FooterBar = ({ testID = '', data }) => {
  return (
    <div data-testid={testID} className={`FooterBar`}>
      <LogoType type={'logo'} text={defaults.logo} size={'small'} />
      <ContactItem type={`email`} value={defaults.email} />

      <ContactItem type={`link`} value={defaults.reai} />
      <ContactItem type={`link`} value={defaults.recognition} />
      <ContactItem type={`link`} value={defaults.roomId} />

      <br />
      <ContactItem type={`link`} value={defaults.linkedin} />
      <ContactItem type={`link`} value={defaults.blog} />
      <ContactItem type={`link`} value={defaults.github} />
      <ContactItem type={`link`} value={defaults.codeberg} />
      <br />

      <ContactItem type={`link`} value={defaults.atomic} />
      <ContactItem type={`link`} value={defaults.ideaCli} />
      <ContactItem type={`link`} value={defaults.npm} />
    </div>
  )
}

FooterBar.propTypes = {
  testID: PropTypes.string,
  data: PropTypes.object
}

export default FooterBar
